import { ErrorHandler, Injectable, Injector } from '@angular/core';

/**
 * Manejador global de errores para Angular
 * Captura errores de Bitwarden y otras extensiones que manipulan el DOM
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: Error | any): void {
    const chunkFailedMessage = /loading chunk \d+ failed/gi;
    const insertBeforeError = /insertBefore|appendChild|removeChild/gi;

    if (chunkFailedMessage.test(error.message)) {
      // Ignorar errores de chunks
      return;
    }

    if (insertBeforeError.test(error.message)) {
      // Ignorar errores de manipulación del DOM de extensiones
      console.debug('Error de DOM capturado y ignorado (probablemente de una extensión):', error.message);
      return;
    }

    // Para otros errores, loguearlos en consola
    console.error('Error capturado por GlobalErrorHandler:', error);
  }
}
